import httpClient from '@/lib/httpClient'
import { handleFormError } from '@/utils/helpers'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useConfirmTodo({ id }: { id: number | string }) {
  const queryClient = useQueryClient()

  const action = async () => {
    const response = await httpClient.post(`team/cash-flow/to-do/${id}`)
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: (res, variables) => {
      toast.success('Confirmed.')
      queryClient.invalidateQueries({ queryKey: ['todos'] })
      queryClient.invalidateQueries({ queryKey: ['todo-count'] })
      queryClient.invalidateQueries({ queryKey: ['todo-summary'] })
      queryClient.invalidateQueries({ queryKey: ['transactions'] })
      // Confirming moves money, which changes the current period's forecast accuracy.
      queryClient.invalidateQueries({ queryKey: ['transactions', 'forecast-score'] })
    },
    // onError: (error, variables) =>
    //   handleFormError({
    //     error,
    //     variables,
    //     setError,
    //     clientServerFieldMapping,
    //   }),
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
